var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"skeleton-card",class:_vm.cardClass,attrs:{"no-body":""}},[_c('b-card-body',{class:_vm.bodyClass},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }